import { requestApi } from '../Api';

export const getConfigSettings = async (navigate, params) => {
  const data = await requestApi({ url: '/api/admin/configurations/list', params, navigate });
  return data;
};

export const updateConfigSettings = async (navigate, params) => {
  const data = await requestApi({
    url: '/api/admin/configurations/upsert',
    params,
    navigate,
    throwError: true
  });
  return data;
};

export const deleteConfigSetting = async (navigate, params) => {
  const data = await requestApi({
    url: '/api/admin/configurations/delete',
    params,
    navigate,
    throwError: true
  });
  return data;
};
